<div *transloco="let t">
	<h2 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">{{ t('tenantunitDetails.uviSettings') }}</h2>
	<mat-dialog-content>
		@if (showManualDeliveryOptionSetting) {
			<mat-form-field name="manualDeliveryOption">
				<mat-label>{{ t('realestateProperties.manualDeliveryOption') }}</mat-label>
				<mat-select [(value)]="manualDeliveryOption">
					@for (option of manualDeliveryOptions; track option) {
						<mat-option [value]="option">
							{{ t('manualDeliveryOption.' + option) }}
						</mat-option>
					}
				</mat-select>
			</mat-form-field>
		}
	</mat-dialog-content>
	<mat-dialog-actions class="flex flex-row justify-end items-center" mat-dialog-actions>
		@if (!sessionService.isNewNavigation()) {
			<button (click)="close(false)" class="m-2" mat-raised-button type="button">
				<mat-icon>cancel</mat-icon>
				@if (!isMobile) {
					<span>
						{{ t('commonActions.cancel') }}
					</span>
				}
			</button>
		}
		<button
			(click)="close(true)"
			class="m-2"
			color="primary"
			mat-raised-button
			type="submit"
			[disabled]="!showManualDeliveryOptionSetting || !manualDeliveryOption">
			<mat-icon>save</mat-icon>
			@if (!isMobile) {
				<span>
					{{ t('commonActions.save') }}
				</span>
			}
		</button>
	</mat-dialog-actions>
</div>
